import * as React from "react";
import { Order_orders_data, Order_orders_data_linked_orders } from '@api/graphql/types';
import { Link } from 'react-router-dom';
import { Paths } from '..';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';

type Props = {
    order: Order_orders_data;
    printMode: boolean;
} & InjectedIntlProps;

interface State {
    links: Array<JSX.Element | string>;
}

class AssociatedLinks extends React.Component<Props, State> {
    public state = {
        links: [],
    };

    public componentDidMount() {
        const { order } = this.props;

        const ids: string[] = [];
        if ((order.parent_order && order.parent_order.id) || (order.linked_orders && order.linked_orders.length > 0)) {
            if (order.parent_order && order.parent_order.id) {
                ids.push(order.parent_order.id);
            }
            if (order.linked_orders && order.linked_orders.length > 0) {
                order.linked_orders.forEach((linkedOrder: Order_orders_data_linked_orders | null) => {
                    if (linkedOrder && linkedOrder.id) {
                        ids.push(linkedOrder.id);
                    }
                });
            }
        }

        const links: Array<JSX.Element | string> = (this.props.printMode) ? ids : (
            ids.map((id: string) => {
                return <Link key={id} to={`${Paths.order}/${id}`} className="parentOrder">{id}</Link>;
            })
        );

        this.setState({ links });
    }

    public render() {
        const { links } = this.state;

        return (links.length > 0) ? (
            <div>
                <hr />
                <h3>{this.props.intl.formatMessage({ id: `module.order.linked_orders.title` })}</h3>
                {links.map((link: JSX.Element | string, index: number) => {
                    return (
                        <div key={`link-${index}`}>
                            {link}
                            {(index < (links.length - 1)) ? <br /> : null}
                        </div>
                    );
                })}
            </div>
        ) : null;
    }
}

export default compose(
    injectIntl,
)(AssociatedLinks);



// WEBPACK FOOTER //
// ./src/modules/Order/components/AssociatedLinks.tsx